import getBlobRequest from 'API/request/getBlobRequest'
import { UPLOADS_ENDPOINT } from '../endpoints/'

export default async ({ id }) => {
  try {
    const response = await getBlobRequest({
      url: `${UPLOADS_ENDPOINT}/${id}`
    })
    // const { data } = response.data
    const status = response.status
    return { status, response: response.data }
  } catch (error) {
    const status = error.response.status
    return { status, response: 'File not found' }
  }
}
